import { COMING_SOON, TEST_PRODUCT_LISTING_CMP_REPORTS } from "@/core/constants";

export function getPatientReportClickDisabled({
  report,
  userReports = [],
  userEntitlements = []
}) {
  const grantedEntitlements =
    report?.purchaseProduct?.grantedEntitlements?.map(entitlement => entitlement.key) ?? [];
  const isLocked = !userEntitlements?.some(
    entitlement => grantedEntitlements.includes(entitlement.key) && entitlement.granted
  );
  const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;
  const userReportIds = userReports.map(userReport => userReport.subsector.id);

  return isComingSoon || (!isLocked && !userReportIds.includes(report.id));
}

export function getCustomerReportClickDisabled({ report }) {
  const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;

  return isComingSoon || !report.isAvailable;
}

export function hasReportEntitlement({ reports = [], userEntitlements = [] }) {
  const grantedKeys = (userEntitlements ?? [])
    .filter(entitlement => entitlement.granted)
    .map(entitlement => entitlement.key);

  return (reports ?? []).some(report =>
    (report?.purchaseProduct?.grantedEntitlements ?? []).some(entitlement =>
      grantedKeys.includes(entitlement.key)
    )
  );
}

export function isPatientReportClickable(params) {
  return !getPatientReportClickDisabled(params);
}

export function isCustomerReportClickable(params) {
  return !getCustomerReportClickDisabled(params);
}

export function findReportForOrderTestItem(orderTestItem, reports = []) {
  return reports.find(report => report.purchaseProduct?.id === orderTestItem?.product?.id);
}

export function isReportOrderTestItem(orderTestItem) {
  return orderTestItem?.product?.listingVisibility === TEST_PRODUCT_LISTING_CMP_REPORTS;
}

export function enrichRowWithReportInfo(
  row,
  { reports = [], userReports = [], userEntitlements = [], reportViewType } = {}
) {
  if (!row.isReport || !reportViewType) {
    return row;
  }

  const report = findReportForOrderTestItem(row.orderTestItem, reports);
  const canClickReport =
    report &&
    (reportViewType === "patient"
      ? isPatientReportClickable({ report, userReports, userEntitlements })
      : isCustomerReportClickable({ report }));

  return {
    ...row,
    report,
    canClickReport
  };
}
